import styled from 'styled-components';

import Button from '@components/Button';

const DefaultButton = styled(Button)`
  font-size: 0.875rem;
  line-height: 1.75 !important;
  letter-spacing: 0.02857em;
  text-transform: uppercase;
  min-width: 64px;
  padding: 6px 16px;
  display: flex;
  align-items: center;
  gap: 5px;
  min-height: 35px;
  width: 100%;
  &.setur-btn {
    padding-top: 6px !important;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    min-height: 39px;
    gap: 0px;
    padding: 6px !important;
    white-space: pre-line;
  }
`;

export const StyledOutlineButton = styled(DefaultButton)`
  border-radius: 0;
  color: #ffffff;
  font-weight: 700;
  border: 1px solid #616364;
  transition: all 0.3s ease;
  text-transform: capitalize;
  background-color: transparent;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    > span > svg {
      display: none;
    }
    width: 53px;
    padding: 2px;
    font-size: 10px !important;
    font-weight: 600 !important;
  }
  &:hover {
    background-color: white;
    color: ${({ theme }) => theme.palette.lightBlack} !important;
    border: 1px solid #616364;
  }
`;

export const StyledPrimaryButton = styled(DefaultButton)`
  background-color: ${({ theme }) => theme.palette.yellow400} !important;
  color: ${({ theme }) => theme.palette.black} !important;
  border-radius: 0;
  font-weight: 700;
  transition: all 0.3s ease;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 10px !important;
    font-weight: 600 !important;

    > span > svg {
      display: none;
    }
  }
`;

export const StyledStack = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 300px;
    margin-bottom: 5px;
    gap: 0px;

    > a {
      text-align: center !important;
      max-width: 100px;
      font-size: 12px;
    }
  }
  ${({ theme }) => theme.mediaQueries.SMALL} {
    max-width: 300px;
    margin-bottom: 5px;
    > a {
      text-align: center !important;
      max-width: 85px;
      font-size: 10px;
    }
  }
`;
